import web from "@/core/middlewares/web";

let home = () => import(/* webpackChunkName: "home" */ '@/views/Home');

export default [
    {
        path: "home",
        name: "home",
        component: home,
        meta: {
            middleware: web,
            title: "پنل مدیریت"
        }
    },
]